import { useFormState, useWatch } from 'react-hook-form';
import { useMemo } from 'react';

export const useClassifierFormCodeAndNameValues = () => {
  const { defaultValues } = useFormState({
    name: ['name', 'code'], // does not seem to have any effect but ok, maybe in future versions it will have
  });
  const name = useWatch({ name: 'name', defaultValue: defaultValues?.name });
  const code = useWatch({ name: 'code', defaultValue: defaultValues?.code });

  return useMemo(() => ({ code, name }), [code, name]);
};
